import React, { useEffect, useState } from "react";
import { Button, Divider, Grid, Paper, Typography, Stack } from "@mui/material";
import "./Cart.css";

import { useSelector } from "react-redux";

import { Link } from "react-router-dom";

const Cart = (props) => {
  const {
    location,
    handleBackToAdd,
    handleCancel,
    stagedStore,
    toggleSaveStagedOrderModal,
    total,
    ordersWithinDeadline,
    handleClickPlaceOrder,
  } = props;

  let eDate = new Date();
  eDate.setDate(eDate.getDate() + 1);

  const eDateString = new Date(
    eDate.getTime() - eDate.getTimezoneOffset() * 60000,
  )
    .toISOString()
    .split("T")[0];

  const cartStore = useSelector((state) => state.cart);
  const customerStore = useSelector((state) => state.customer);

  const [displayFAB, setDisplayFAB] = useState(false);

  const hasRefrigeratedDeliveryFee = Boolean(
    customerStore?.company_location_data[0]?.refrigerated_delivery_fee,
  );

  const hasFuelSurchargeFee = Boolean(
    customerStore?.company_location_data[0]?.fuel_surcharge_fee,
  );

  const isCODPaymentEnabled = Boolean(
    customerStore?.company_location_data[0]?.cod_payments_enabled,
  );

  const applyDeliveryFee =
    total <
    (customerStore?.company_location_data[0]?.omit_delivery_fee_threshold || 0);

  const displayCODBreakdown =
    isCODPaymentEnabled &&
    hasRefrigeratedDeliveryFee &&
    applyDeliveryFee &&
    ordersWithinDeadline.length === 0;

  const displayBreakdown =
    !isCODPaymentEnabled && (hasFuelSurchargeFee || hasRefrigeratedDeliveryFee);

  const grandTotal =
    total +
    (displayCODBreakdown || displayBreakdown
      ? customerStore?.company_location_data[0]?.refrigerated_delivery_fee || 0
      : 0) +
    (displayBreakdown
      ? customerStore?.company_location_data[0]?.fuel_surcharge_fee || 0
      : 0);

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 520) {
        setDisplayFAB(true);
      } else {
        setDisplayFAB(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Paper className="rootPaper">
      <Grid container spacing={2} padding={3}>
        <Grid item xs={12}>
          <Typography variant="subtitle1">
            <strong>Estimated Delivery: </strong>
            {eDateString}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="subtitle1">
            {displayBreakdown || displayCODBreakdown ? "Subtotal:" : "Total:"}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h6" align="right">
            ${total.toFixed(2)}
          </Typography>
        </Grid>
        {(displayBreakdown || displayCODBreakdown) && (
          <>
            <Grid item xs={6}>
              <Typography variant="subtitle1">
                {displayCODBreakdown
                  ? "Delivery Fee:"
                  : "Refrigerated Delivery Fee:"}
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h6" align="right">
                $
                {(
                  customerStore?.company_location_data[0]
                    ?.refrigerated_delivery_fee || 0
                ).toFixed(2)}
              </Typography>
            </Grid>
            {displayBreakdown && hasFuelSurchargeFee && (
              <>
                <Grid item xs={6}>
                  <Typography variant="subtitle1">
                    {displayCODBreakdown
                      ? "Delivery Fee:"
                      : "Fuel Surcharge Fee:"}
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="h6" align="right">
                    $
                    {(
                      customerStore?.company_location_data[0]
                        ?.fuel_surcharge_fee || 0
                    ).toFixed(2)}
                  </Typography>
                </Grid>
              </>
            )}
          </>
        )}
        {(displayBreakdown || displayCODBreakdown) && (
          <>
            <Grid item xs={6}>
              <Typography variant="subtitle1">Grand Total:</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="h6" align="right">
                ${grandTotal.toFixed(2)}
              </Typography>
            </Grid>
          </>
        )}
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item xs={12}>
          {!displayFAB ? (
            <Stack direction="column" spacing={1}>
              {!location.search.includes("stagedOrder=1") ? (
                <>
                  <Button
                    fullWidth
                    color="info"
                    variant="contained"
                    onClick={toggleSaveStagedOrderModal}
                    disabled={total === 0}
                  >
                    Save to Staged Order
                  </Button>
                  {stagedStore.length ? (
                    <Link
                      to="/cart?stagedOrder=1"
                      style={{ textDecoration: "none" }}
                    >
                      <Button fullWidth color="warning" variant="contained">
                        View Staged Order
                      </Button>
                    </Link>
                  ) : (
                    <Button
                      fullWidth
                      color="warning"
                      variant="contained"
                      disabled={true}
                    >
                      View Staged Order
                    </Button>
                  )}
                </>
              ) : (
                <>
                  {cartStore[customerStore.id] ? (
                    cartStore[customerStore.id].products.length ? (
                      <Link to="/cart" style={{ textDecoration: "none" }}>
                        <Button fullWidth color="warning" variant="contained">
                          View Order
                        </Button>
                      </Link>
                    ) : (
                      <Button
                        variant="contained"
                        disabled={!cartStore[customerStore.id].products.length}
                      >
                        View Order
                      </Button>
                    )
                  ) : (
                    <></>
                  )}
                </>
              )}
              <Button
                fullWidth
                color="inherit"
                variant="contained"
                onClick={handleBackToAdd}
              >
                Continue Shopping
              </Button>
              <Button
                fullWidth
                color="error"
                variant="contained"
                onClick={handleCancel}
              >
                Go Back to Orders
              </Button>
            </Stack>
          ) : (
            <div style={{ height: 215 }} />
          )}
        </Grid>
        <Grid item xs={12}>
          {displayFAB ? (
            <div style={{ position: "fixed", bottom: 10, right: 10 }}>
              <Stack direction="column" spacing={1}>
                <Button
                  fullWidth
                  color="success"
                  variant="contained"
                  onClick={handleClickPlaceOrder}
                  className="place-order-button"
                >
                  Place Order
                </Button>
                {!location.search.includes("stagedOrder=1") ? (
                  <>
                    <Button
                      fullWidth
                      color="info"
                      variant="contained"
                      onClick={toggleSaveStagedOrderModal}
                    >
                      Save to Staged Order
                    </Button>
                    {stagedStore.length ? (
                      <Link
                        to="/cart?stagedOrder=1"
                        style={{ textDecoration: "none" }}
                      >
                        <Button fullWidth color="warning" variant="contained">
                          View Staged Order
                        </Button>
                      </Link>
                    ) : (
                      <Button
                        fullWidth
                        color="warning"
                        variant="contained"
                        disabled={true}
                      >
                        View Staged Order
                      </Button>
                    )}
                  </>
                ) : (
                  <>
                    {cartStore[customerStore.id] ? (
                      cartStore[customerStore.id].products.length ? (
                        <Link to="/cart" style={{ textDecoration: "none" }}>
                          <Button fullWidth color="warning" variant="contained">
                            View Order
                          </Button>
                        </Link>
                      ) : (
                        <Button
                          variant="contained"
                          disabled={
                            !cartStore[customerStore.id].products.length
                          }
                        >
                          Cart
                        </Button>
                      )
                    ) : (
                      <></>
                    )}
                  </>
                )}
                <Button
                  fullWidth
                  color="inherit"
                  variant="contained"
                  onClick={handleBackToAdd}
                >
                  Continue Shopping
                </Button>
                <Button
                  fullWidth
                  color="error"
                  variant="contained"
                  onClick={handleCancel}
                >
                  Go Back to Orders
                </Button>
              </Stack>
            </div>
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Cart;
